import React from "react";
import PropTypes from "prop-types";
import styles from "./breadCrumbs.scss";
import { getOrigin } from "../../utils/helper";
import { getQueryUTMString } from "@tw/shared-ui-components/lib/utils/helper";
const BreadCrumbs = ({
  list,
  lastChildName,
  Link,
  isSop,
  NextHead,
  isStructuredData,
}) => {
  if (!list) {
    return null;
  }

  const NextLink = Link || "a";

  const fontWeightForLastBread = 700;
  const checkIsLast = (i) => {
    let lastEl = list?.length - 1;
    if (lastChildName) return undefined;
    if (lastEl === i) return fontWeightForLastBread;
    else return undefined;
  };

  const getStructuredData = (list) => {
    let structuredData = {};
    let listElements = [];

    //20220823: filter out categoryCode == root, in PD data
    let filteredList = list?.filter((item) => item.categoryCode != 'root' && item.categoryName != null);
    filteredList.map((nav, i) => {
      listElements[i] = {
        "@type": "ListItem",
        position: i + 1,
        name: nav?.categoryName,
        item: nav?.categoryCode
          ? `${getOrigin()}/${"category"}/${nav.categoryCode}`
          : nav?.link || "#",
      };
    });

    if (lastChildName) {
      listElements.push({
        "@type": "ListItem",
        position: filteredList.length + 1,
        name: lastChildName,
      });
    }

    structuredData = {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemlistElement: listElements,
    };
    return JSON.stringify(structuredData);
  };
  const filterBreadcrumbLinks = (nav) => {
    let param = getQueryUTMString("?");
    if (nav.categoryCode) {
      return `/${isSop ? "sop" : "category"}/${nav.categoryCode}${param}`
    } else {
      return nav.link || "#"
    }
  }
  return (
    <>
      {isStructuredData && (
        <NextHead>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: getStructuredData(list) }}
          ></script>
        </NextHead>
      )}
      <nav>
        <ol className={styles["breadcrumbs"]}>
          {list.map((nav, i) => {
            if (!nav.categoryName) return null;
            return (
              <>
                <li key={i} className={styles["link"]}>
                  <NextLink
                    href={
                      filterBreadcrumbLinks(nav)
                    }
                    passHref
                  >
                    <a
                      className={styles["link-text"]}
                      style={{ fontWeight: checkIsLast(i) }}
                    >
                      {nav.categoryName}
                    </a>
                  </NextLink>
                </li>
                <span className={styles["slash"]}>
                  &nbsp;{i < list.length - 1 || !!lastChildName ? "/" : ""}
                  &nbsp;
                </span>
              </>
            );
          })}
          {
            <li
              className={styles["link-last"]}
              style={
                lastChildName
                  ? { fontWeight: fontWeightForLastBread }
                  : undefined
              }
            >
              {lastChildName}
            </li>
          }
        </ol>
      </nav>
    </>
  );
};

BreadCrumbs.defaultProps = {
  isStructuredData: false,
  // list: [{
  //     categoryName: "Navigation 1",
  //     categoryCode: "1234"
  // }, {
  //     categoryName: "Navigation 2",
  //     categoryCode: "1234"
  // }, {
  //     categoryName: "Navigation 3",
  //     categoryCode: "1234"
  // }],
  // lastChildName: 'Product 1'
};

BreadCrumbs.propTypes = {
  // list: PropTypes.array,
  isStructuredData: PropTypes.bool,
};

export default BreadCrumbs;
